import styled, { css, ThemeProps, DefaultTheme } from 'styled-components'
import { BoxProps, withBox } from 'components/Box'
import { Type } from './types'

const buttonUnstyledStyles = css`
  border: none;
  background-color: transparent;
  appearance: none;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};

  &[disabled] {
    pointer-events: none;
  }

  &:active {
    outline: 0;
  }
`

const ButtonUnstyled = styled(withBox('button'))<
  ThemeProps<DefaultTheme> & OmitSafe<BoxProps, 'color'> & { type?: Type }
>`
  ${buttonUnstyledStyles};
`

ButtonUnstyled.defaultProps = {
  p: 0,
  type: 'button',
}

export { buttonUnstyledStyles, ButtonUnstyled }
